// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"13119862","496":"d2cb84f3","728":"ab38105d"}[chunkId] + ".chunk.js";
};